// const getText = () => {
//     return '日利率'
// };
const BANK_NAME = '秦农银行';
const PRODUCT_NAME = '网贷';

const textConfig = {
    //首页
    home: {
        //未注册
        notRegister: {
            top: '最高可借额度',
            //bottom: getText()
            bottom: `日利率最低万2`
        },
        //正常用户
        active: {
            top: '可借额度',
            bottom: '总额度&yen;{{totalLoanAmount}}，'
            //bottom: `总额度&yen;{{totalLoanAmount}}，日利率{{oQuery.dayRate || '0.05'}}%`
        },
        //借款按钮
        loanBtn: {
            loan: '立即借款',
            apply: '立即申请',
        },
        //特性
        grid: ['极速到账', '智能审批'],
        repayment: {
            left_order: '提前还款',
            total_repay_amount: '本月应还'
        },
        footer: `${BANK_NAME}客服电话 `,
        footerPhone: '',       // 400-677-0537
    },
    //借款
    loan: {
        index: {
            amount: '借款金额',
            period: '还款期数',
            rateType: '还款方式',
            repayType: '还款周期',
            repayDate: '还款日期',
            loanUsage: '资金用途',
            repayDetail: {
                label: '还款计划',
                view: '查看'
            },
            card_bank_code: '收款银行卡',
            //协议
            agreement: {
                label: '请仔细阅读上述借款信息，点击确认借款表示同意签订',
                links: ['《合同及相关协议》'],
            },
            pop: {
                //日利率说明
                dayRate: `<h3>①  年化利率（单利）</h3>
                <p>假设年化利率（单利）是3.60%，日利率＝年化利率（单利）/360，日利率为0.01%，借款10000元每日利息1元，已还本金不算利息；</p>
                <h3>②  还款方式</h3>
                <p>
                    根据分期期数，每月还本金以及当月利息；<br/>
                    您还可以随时提前还清整笔借款，按实际借款天数算利息；
                </p>
                <h3>③  放款说明</h3>
                <p>
                    正常模式下预计10分钟内到账；<br/>
                    夜间模式（21:00-23:00）到账时间可能延后至上午5点后
                </p>
                <h3>④  日利率计算</h3>
                <p>
                    日利率以上个工作日全国银行间同业拆借中心公布的1年期贷款市场报价利率（LPR），加/减相应基点（1基点=0.01%）计算得出，详见《借款合同》
                </p>`,
                //资金用途说明
                loanUsage: `仅限用于个人消费支出，
                如日常消费、装修、购买家具家电、购车、旅游、教育、医疗美容等<br/><br/>
                不得用于以下领域：从事股本权益性投资，以贷款作为注册资金、注册验资或增资扩股；
                购买股票、基金、理财产品、金融衍生产品等；
                从事非法借贷、非法集资；及国家有关法律、法规和规章禁止的其他用途。`,
                //还款日期说明
                repayDate: `还款日计算以借款实际到账日为准。<br/><br/>
                放款时间在1~25日期间，则还款日为下月的1~25日的对日（例如9月15日放款，则第一期还款日即为10月15日）；若放款时间在26~31日期间，则还款时间为次月25日。`,
                repayDetail: {
                    principal_per_period: '本期应还本金',
                    total_interest: '借款期满总利息'
                }
            },
            //mint-ui下拉选择
            mtPop:{
                cancel: '取消',
                select: '确定'
            }
        },
        auth: {
            top: {
                identity: '身份证认证',
                faceid: '人脸认证'
            },
            bottom: {
                agreement: `${BANK_NAME}相关合同及协议`
            }
        },
        //人脸验证
        faceidVerify: {
            top: {
                title: '人脸识别',
                desc: '请在光线充足的环境下进行'
            },
            center: {
                fail: {
                    status: '认证失败',
                    btn: '重新认证'
                },
                success: {
                    status: '认证成功',
                }
            },
        },
        //身份证验证
        idAuth: {},
        //放款中等待...
        polling: {
            top: {
                status: '处理中',
                desc: {
                    day: `预计<em class="red">10</em>分钟内到账`,
                    //夜间模式
                    night: ''
                }
            },
            center: {
                apply_amount: '借款金额',
                repay_amount: '首次还款金额',
                repay_date: '首次还款日'
            },
            bottom: {
                btn: '完成'
            }
        },
        //结果
        result: {
            top: {
                repay: `恭喜您<br/>放款成功`,
                refuse: `对不起<br/>由于您的信用资质不够<br/>申请失败`,
                grant_fail: `您的放款已放置您的${BANK_NAME}电子账户<br/>请至银行卡管理查看余额`
            },
            btn: {
                repay: '再借一笔',
                refuse: '再试一次',
                grant_fail: '银行卡管理'
            },
            bottom: {
                repay: '返回首页',
                refuse: '返回首页',
                grant_fail: '返回首页'
            }
        }
    },
    //额度
    quotaQuery: {
        //填写信息
        index: {
            list: ['','','','','',''],
            top: {
                id_card: '身份证',
                user_name: '姓名',
                supportBanks: '收款银行卡',
                phone_number: '银行预留手机号',
                sms_verify_code: '手机验证码',
                verifyCode: '获取验证码'
            },
            bottom: {
                agreement: `${BANK_NAME}相关协议及授权`
            },
        },
        //人脸验证
        faceidVerify: {
            top: {
                title: '人脸识别',
                desc: '请在光线充足的环境下进行'
            },
            center: {
                fail: {
                    status: '认证失败',
                    btn: '重新认证'
                },
                success: {
                    status: '认证成功',
                }
            },
        },
        //身份证信息确认
        idCardConfirm: {
            top: {
                id_card: '身份证',
                user_name: '姓名'
            }
        },
        //额度等待
        polling: {
            top: {
                status: '额度评估中',
                desc: `评估结果短信<em class="red">3</em>分钟内发送到您的手机`
            },
            bottom: {
                btn: '完成'
            }
        },
        //结果
        result: {
            status: {
                no_quali: '无可用额度',
                re_verify: '额度已过期'
            },
            desc: {
                no_quali: '对不起，暂无可用额度，请30天后尝试',
                re_verify: '额度有效期为一个月，请重新评估额度'
            },
            btn: {
                no_quali: '关闭',
                re_verify: '立即申请'
            }
        }
    },
    //还款
    repayment: {
        top: {
            nav: {
                left: '按期还款',
                right: '提前还款'
            }
        },
        planList: {
            repayAmount: {
                top: '本月应还',
                bottom: `支持转入${BANK_NAME}电子账户自动扣款`
            },
            list: {
                top: '应还详情',
                borrow: '借款',
                repay: '本期应还',
                repayDate: '还款日',
                overdueAmount: '主动还款',
                overdueDay: '逾期',
                bottom: `您本期还款已进入宽限期({remain_extend_days}天)，请尽快结清！`
            },
            footer: {
                btn: '还款',
                left: '借款记录',
                right: '还款记录'
            },
            pop: {
                content: `<p>电子账户支持转入资金，请前往绑定银行卡的手机银行或者网银进行转账。</p>
                <p>您可在个人中心-电子账户中查看电子账户的账户号。</p>`
            }
        },
        repaymentList: {
            list: {
                borrow: '借款',
                repayDate: '还款日',
                overdueAmount: '主动还款',
                overdueDay: '逾期'
            },
            allCheck: '全选',
            btn: '还款'
        }
    },
    //借款详情
    detail: {
        loan: {
            top: '借款',
            center: {
                firstPeriod: '第1期',
                current_periods: `第{current_periods}期应还款 `,
                periods: '第{periods}期',
                finish: '已结清'
            },
            list: {
                arrears_amount: '拖欠金额',
                repaid_amount: '已还金额',
                should_repay_amount: '待还金额',
                repayPlan: '还款计划',
                partCleanUp: '部分提前还款',
                moreDetail: '更多详情',
            },
            pop2RepayPlan: {
                repayDate: '还款日期',
                shouldRepay: '应还',
                getting: '还款计划获取中...'
            },
            mtPopUp: {
                headerLeft: '待还款期数',
                headerRight: '取消',
                repayDate: '还款日',
                allCheckbox: '全选',
                totalAmount: '全计',
                btn: '确定'
            }
        },
        more: {
            card_info: '收款账户',
            product_interest_day_rate: '日利率',
            time: '起止时间',
            first_repay: '首次还款',
            name: '借款人姓名',
            identity: '借款人身份证',
            repay_msg: '还款日',
            product_period_count: '借款期限',
            periodCountValue: `{product_period_count}个月(期)`,
            apply_loan_purpose_cn: '资金用途',
            agreement: '借款合同',
        }
    },
    //借款，还款记录
    record: {

    },
    //支付
    pay: {
        index: {
            top: {
                payAmount: {
                    recharge: '转入金额',
                    notRecharge: '还款金额',
                },
                bottom: '已抵用电子账户还款优惠红包'
            },
            center: {
                type: '支付方式',
                cardII: `${BANK_NAME}电子账户余额`,
                wechat: '微信支付'
            },
            bottom: {
                btn: '确定支付'
            },
            pop: {
                content: `<p>电子账户支持转入资金，请前往绑定银行卡的手机银行或者网银进行转账。</p>
                <p>您可在个人中心-电子账户中查看电子账户的账户号。</p>`
            },
            bankName: BANK_NAME
        },
        result: {
            top: {
                status: {
                    submitSuccess: '提交成功',
                    repaySuccess: '还款成功'
                },
                desc: '还款已提交银行处理'
            },
            center: {
                day: `预计<em class="red">10</em>分钟内处理完成`,
                //夜间模式
                night: '',
                //提前还清
                clean: '还款成功后额度将实时恢复'
            },
            bottom: {
                btn: '完成',
                couponTxt: '点此领取还款优惠券'
            }
        },
        //红包
        discount: {
            content: {
                top: {
                    success: '恭喜你获得',
                    fail: '很遗憾'
                },
                center: {
                    success: '还款优惠券',
                    fail: '未获得优惠券'
                },
                money: '元',
                bottom: `红包已为您领取至个人中心<br/>下次还款时即可使用哦`
            },
            btn: '返回'
        }
    },
    //个人中心
    user: {
        //个人中心首页
        index: {
            second_account: `${BANK_NAME}电子账户`,
            individual_card_num: '银行卡管理',
            record: '借还记录',
            helper: '常见问题',
            individual_extend_company: '企业信息',
            contact: '联系人信息',
            work: '职业信息',
            coupon: '优惠券',
            useProf: '上传用款证明'
        },
        //添加联系人
        addContact: {
            title: '联系人信息',
            contact: {
                type: '关系',
                name: '姓名',
                phone: '手机号码'
            }
        },
        //银行卡管理
        bankCardManagement: {
            cardName: '储蓄卡',
            btn: '更换银行卡'
        },
        //企业信息
        companyManage: {
            company: {
                typeText: '经营类型',
                individual_extend_company: '企业名称'
            }
        },
        //联系人信息
        contactManage: {
            contacts: {
                individual_contact_type: '联系人',
                individual_contact_name: '姓名',
                individual_contact_phone: '手机号'
            }
        },
        //职业信息
        workInfo: {
            job: '一级职业',
            sub_job: '二级职业',
            job_address: '职业地址',
            home_address: '居住地址'
        },
        //电子账户
        account: {
            top: '余额',
            list: ['账户名：', '账户号码：'],
            btn: '提现',
            btnIn: '充值',
            pop: {
                content: `<p>1.电子账户余额可用于<span class="red">每月按期还款</span>或<span class="red">提前结清借款</span>支付使用，还款前请确保电子账户资金余额充足；<br/><br/></p>
                <p>2.${BANK_NAME}电子账户仅支持您通过已绑定的收款银行卡【<span class="red">{bank_name} 尾号{individual_card_num}</span>】进行资金转入，您可通过登录已绑定银行卡发卡行手机银行客户端或网银转账进行资金转入；<br/><br/></p>
                <p>3.电子账户余额未使用部分，可用于继续抵扣剩余应还款金额或转出至您当前绑定的收款银行卡；</p>`
            }
        },
        //用户信息
        info: {
            individual: {
                name: '姓名',
                identity: '身份证',
                mobile: '手机号'
            }
        },
        //上传用款凭证
        loanOrder: {
            top: '首笔订单首次上传用款证明，有机会领取还款优惠红包~'
        },
        //上传用款凭证
        uploadProf: {
            bottom: '根据国家法律规定，贷款用户应告知银行真实的贷款用途，并提供详细的用款证明文件。',
            bottomLink: '上传用款证明文件要求',
            pop: {
                content: `<p>1、请上传清晰、完整的彩色用款证明照片，并保证用款发生时间在借款时间段之内。</p>
                <p>2、证明文件包括且不限于在淘宝、京东等电商消费的订单截屏图片以及正规的线上、线下消费的发票或票据等。</p>
                <p>3、用款证明照片的各项信息应清晰可见，易于识别。</p>
                <p>4、用款证明照片必须真实拍摄，不得使用复印件和扫描件。</p>
                <p>5、照片格式必须为JPG或PNG。</p>
                <p>6、建议横屏拍摄，以满足照片上传要求。</p>`
            }
        }
    },
    //客户问题
    helper: {

    },
    //非白名单
    notWhitePage: {
        top: {
            desc: `感谢您注册${BANK_NAME}${PRODUCT_NAME}，申请资格逐步开放中，对您开放后第一时间通知您，敬请留意。`
        },
        bottom: {
            apply: '在线申请',
            pass: '快速审批',
            fast: '期限灵活'
        }
    },
    //ocr
    ocr: {
        top: '请上传二代身份证',
        front: {
            middle: '重拍',
            leftBottom: '仅供本次服务使用',
            bottom: '上传身份证人像面'
        },
        back: {
            middle: '重拍',
            leftBottom: '仅供本次服务使用',
            bottom: '上传身份证国徽面'
        },
        bottom: {
            tip: '本次操作将严格保护您的隐私安全，请放心操作',
            btn: '上传识别'
        }
    }
};

export default textConfig;



// WEBPACK FOOTER //
// ./src/common/js/textConfig.js